module.exports = {
	LOG_IN_LINK:'https://www.plickers.com/login',
	// LOG_IN_LINK:'http://localhost:3000/login',
	CREATE_ACCOUNT_LINK:'https://www.plickers.com/signup',
	DOWNLOAD_ANDROID_APP_LINK:'https://play.google.com/store/apps/details?id=com.plickers.client.android',
	DOWNLOAD_IOS_APP_LINK:'https://itunes.apple.com/us/app/plickers/id701184049?mt=8',
	PRIVACY_POLICY_LINK:'https://help.plickers.com/hc/en-us/articles/360009090833-Plickers-Privacy-Policy',
	TERMS_OF_SERVICE_LINK:'https://help.plickers.com/hc/en-us/articles/360009090913-Terms-of-Service',
	SUPPORT_LINK:'https://help.plickers.com/',
	GET_CARDS_LINK:'https://help.plickers.com/hc/en-us/articles/360008948034-Get-Plickers-Cards',	
}

